<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">

                                        <div class="page-body">

                                            <div class="row">
                                                <div class="col-md-12 col-xl-12">
                                                    <div class="card summery-card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Roles</h5>
                                                            </div>
                                                            <div class="card-header-right">
                                                                <button v-if="$checkPerm('roles.create')" data-toggle="modal"
                                                                    data-target="#addRole" class="btn btn-primary btn-sm btn-mat">Add
                                                                    Role</button>
                                                            </div>
                                                        </div>
                                                        <div class="card-block">
                                                            <div class="table-responsive">
                                                                <table class="table table-hover">
                                                                    <thead>
                                                                        <th>ID</th>
                                                                        <th>Role Name</th>
                                                                        <th>Actions</th>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(role, index) in roles">
                                                                            <td>{{role.id}}</td>
                                                                            <td>{{role.role_name}}</td>
                                                                            <td>
                                                                                <button class="btn btn-primary btn-sm btn-mat"
                                                                                    data-toggle="modal"
                                                                                    v-bind:data-target="'#role' + role.id">View
                                                                                    Permissions</button>&nbsp
                                                                                <button class="btn btn-primary btn-sm btn-mat"
                                                                                    v-if="$checkPerm('roles.create')"
                                                                                    data-toggle="modal"
                                                                                    v-bind:data-target="'#editRole' + role.id">Edit Role 
                                                                                    Permission
                                                                                </button>&nbsp
                                                                                <!-- <button class="btn btn-success btn-sm btn-mat"
                                                                                    v-if="$checkPerm('roles.create')"
                                                                                    data-toggle="modal"
                                                                                    v-bind:data-target="'#updateRole' + role.id">Edit
                                                                                    Role
                                                                                </button> -->
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$checkPerm('roles.create')" id="addRole" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Add
                            Process.</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="createRole">
                            <div class="form-group">
                                <label>Role
                                    Name:</label>
                                <input type="text" class="form-control" name="process_name" placeholder="Role Name"
                                    v-model="new_role.role_name" required="required" />
                            </div>
                            <div class="form-group">
                                <b>Permissions:</b>
                                <hr>
                                <div class="row m-t-20">
                                    <div class="col-lg-6">
                                        <div>
                                            <b class="m-t-10">Opening:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.opening.create" name="" />
                                                Create
                                                Opening
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.opening.delete" name="" />
                                                Delete
                                                Opening
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.opening.edit" name="" />
                                                Edit
                                                Opening
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Archive
                                                Applications:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.archived_applications.view"
                                                    name="" />
                                                View
                                                archived
                                                applications.
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Applications:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.share_to_hiring_manager"
                                                    name="" />
                                                Share
                                                application
                                                to
                                                hiring
                                                manager.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.approve_to_stage_2"
                                                    name="" />
                                                Approve
                                                application
                                                to
                                                "Stage
                                                2".
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.archive"
                                                    name="" />
                                                Archive
                                                application.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.unarchive"
                                                    name="" />
                                                Unarchive
                                                application.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.discontinue"
                                                    name="" />
                                                Discontinue
                                                application.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.approve_for_interview"
                                                    name="" />
                                                Approve
                                                for
                                                interview.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.view_applicant_submissions"
                                                    name="" />
                                                View
                                                applicant
                                                "Stage
                                                2"
                                                submissions.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.create_hiring_note"
                                                    name="" />
                                                Create
                                                hiring
                                                notes.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.view_hiring_note"
                                                    name="" />
                                                View
                                                all
                                                hiring
                                                notes.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.use_scorecard"
                                                    name="" />
                                                Assess
                                                applicant.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.view_all_scorecard_assesments"
                                                    name="" />
                                                View
                                                all
                                                assesment
                                                scorecards.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.use_practical_evaluation"
                                                    name="" />
                                                Do
                                                practical
                                                evaluation.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.assign_to_evaluator"
                                                    name="" />
                                                Can
                                                assign to
                                                evaluator
                                            </div>
                                            </li>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.send_to_hiring_approver"
                                                    name="" />
                                                Send
                                                application
                                                to
                                                hiring
                                                approver.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.approve_hiring"
                                                    name="" />
                                                Approve
                                                for
                                                hiring.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.forward_offer_to_approver"
                                                    name="" />
                                                Forward
                                                offer
                                                letter
                                                to
                                                approver.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.approve_offer"
                                                    name="" />
                                                Approve
                                                offer
                                                letter.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.forward_offer_to_candidate"
                                                    name="" />
                                                Forward
                                                offer
                                                to
                                                candidate.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.recruit_hr_live"
                                                    name="" />
                                                Recruit
                                                to
                                                HR
                                                Live.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.application.send_email"
                                                    name="" />
                                                Send
                                                applicant
                                                emails.
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div>
                                            <b class="m-t-10">Process:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.process.create" name="" />
                                                Create
                                                Process
                                            </div>
                                            <p>CBT:</p>
                                            <div class="m-l-20">
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="role_permissions.process.cbt.create"
                                                        name="" />
                                                    Create
                                                    CBT
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="role_permissions.process.cbt.view"
                                                        name="" />
                                                    View
                                                    CBT
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="role_permissions.process.cbt.assign_to_opening"
                                                        name="" />
                                                    Assign
                                                    CBT
                                                    to
                                                    Opening
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="role_permissions.process.cbt.add_questions"
                                                        name="" />
                                                    Add
                                                    questions
                                                    to
                                                    a
                                                    CBT
                                                    test.
                                                </div>
                                            </div>
                                            <p>Video
                                                Instructions:</p>
                                            <div class="m-l-20">
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="role_permissions.process.video_instructions.view"
                                                        name="" />
                                                    View
                                                    new
                                                    Video
                                                    Instructions.
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="role_permissions.process.video_instructions.create"
                                                        name="" />
                                                    Create
                                                    new
                                                    Video
                                                    Instructions.
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="role_permissions.process.video_instructions.edit"
                                                        name="" />
                                                    Edit
                                                    Video
                                                    Instructions.
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="role_permissions.process.video_instructions.delete"
                                                        name="" />
                                                    Delete
                                                    Video
                                                    Instructions.
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Offer
                                                Templates:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.offer_template.create"
                                                    name="" />
                                                Create
                                                Offer
                                                Templates
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.offer_template.edit"
                                                    name="" />
                                                Edit
                                                Offer
                                                Templates
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.offer_template.view"
                                                    name="" />
                                                View
                                                Offer
                                                Templates
                                            </div>

                                        </div>

                                        <div>
                                            <b class="m-t-10">Scorecard:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.scorecard.edit" name="" />
                                                Create
                                                Scorecards
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.scorecard.view" name="" />
                                                Edit
                                                Scorecards
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Users:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.users.create" name="" />
                                                Create
                                                User
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.users.delete" name="" />
                                                Delete
                                                User
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.users.modify" name="" />
                                                Edit
                                                User
                                            </div>
                                            <!----<div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.users.change_role"
                                                    name="" />
                                                Edit
                                                role
                                            </div>-->
                                        </div>

                                        <div>
                                            <b class="m-t-10">Roles:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.roles.create" name="" />
                                                Create
                                                Roles
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.roles.delete" name="" />
                                                Delete
                                                Roles
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.roles.modify" name="" />
                                                Modify
                                                Roles
                                            </div>
                                        </div>
                                        <div>
                                            <b class="m-t-10">Report:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.report.view" name="" />
                                                View
                                                Report
                                            </div>

                                        </div>
                                        <div>
                                            <b class="m-t-10">Social Media:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.socialmedia.create"
                                                    name="" />

                                                Share Social Media Link
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-primary">Create</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="$checkPerm('roles.create')" v-for="role in roles" v-bind:id="'role' + role.id" class="modal fade"
            role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{role.role_name}}
                            permissions.</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">

                        <div class="p-b-10">
                            <h4 class="sub-title">Openings</h4>
                            <ul>
                                <li v-if="role.role_permissions.opening.create">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can create openings.
                                </li>
                                <li v-if="role.role_permissions.opening.delete">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can delete openings.
                                </li>
                                <li v-if="role.role_permissions.opening.edit">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can edit openings.
                                </li>
                            </ul>
                        </div>

                        <div class="p-b-10">
                            <h4 class="sub-title">Archived
                                Applications</h4>
                            <ul>
                                <li v-if="role.role_permissions.archived_applications.view">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can view archived applications.
                                </li>
                            </ul>
                        </div>

                        <div class="p-b-10">
                            <h4 class="sub-title">Applications</h4>
                            <ul>
                                <li v-if="role.role_permissions.application.share_to_hiring_manager">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can share to hiring manager.
                                </li>
                                <li v-if="role.role_permissions.application.approve_to_stage_2">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can approve applicant for Stage
                                    2.
                                </li>
                                <li v-if="role.role_permissions.application.archive">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can archive applicant.
                                </li>
                                <li v-if="role.role_permissions.application.unarchive">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can unarchive applicant.
                                </li>
                                <li v-if="role.role_permissions.application.discontinue">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can discontinue applicant.
                                </li>
                                <li v-if="role.role_permissions.application.approve_for_interview">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can approve for interview.
                                </li>
                                <li v-if="role.role_permissions.application.view_applicant_submissions">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can view Stage 2 submissions.
                                </li>
                                <li v-if="role.role_permissions.application.create_hiring_note">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can create hiring note.
                                </li>
                                <li v-if="role.role_permissions.application.view_hiring_note">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can view all hiring notes.
                                </li>
                                <li v-if="role.role_permissions.application.use_scorecard">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can assess applicant.
                                </li>
                                <li v-if="role.role_permissions.application.view_all_scorecard_assesments">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can view all scorecard
                                    assesments.
                                </li>
                                <li v-if="role.role_permissions.application.use_practical_evaluation">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can do practical evaluation.
                                </li>
                                <li v-if="role.role_permissions.application.send_to_hiring_approver">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can forward applicant for
                                    hiring approval.
                                </li>
                                <li v-if="role.role_permissions.application.approve_hiring">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can approve for hiring.
                                </li>
                                <li v-if="role.role_permissions.application.forward_offer_to_approver">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can forward letter to approver.
                                </li>
                                <li v-if="role.role_permissions.application.approve_offer">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can approve offer.
                                </li>
                                <li v-if="role.role_permissions.application.forward_offer_to_candidate">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can foward offer to candidate.
                                </li>
                                <li v-if="role.role_permissions.application.recruit_hr_live">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can share to hiring manager.
                                </li>
                                <li v-if="role.role_permissions.application.send_email">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can send applicant email.
                                </li>
                                <li v-if="role.role_permissions.application.assign_to_evaluator">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can Assign to evaluator.
                                </li>
                            </ul>
                        </div>

                        <div class="p-b-10">
                            <h4 class="sub-title">Processes</h4>
                            <ul>
                                <li v-if="role.role_permissions.process.create">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can create processes.
                                </li>
                                <li>
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    CBT
                                    <ul>
                                        <li v-if="role.role_permissions.process.cbt.create">
                                            <i class="icofont icofont-stylish-right text-danger"></i>
                                            Can create CBT.
                                        </li>
                                        <li v-if="role.role_permissions.process.cbt.view">
                                            <i class="icofont icofont-stylish-right text-danger"></i>
                                            Can view CBT.
                                        </li>
                                        <li v-if="role.role_permissions.process.cbt.assign_to_opening">
                                            <i class="icofont icofont-stylish-right text-danger"></i>
                                            Can assign CBT to
                                            opening.
                                        </li>
                                        <li v-if="role.role_permissions.process.cbt.add_questions">
                                            <i class="icofont icofont-stylish-right text-danger"></i>
                                            Can add questions.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Video Instructions
                                    <ul>
                                        <li v-if="role.role_permissions.process.video_instructions.create">
                                            <i class="icofont icofont-stylish-right text-danger"></i>
                                            Can create Video
                                            Instructions.
                                        </li>
                                        <li v-if="role.role_permissions.process.video_instructions.edit">
                                            <i class="icofont icofont-stylish-right text-danger"></i>
                                            Can edit Video
                                            Instructions.
                                        </li>
                                        <li v-if="role.role_permissions.process.video_instructions.delete">
                                            <i class="icofont icofont-stylish-right text-danger"></i>
                                            Can delete Video
                                            Instructions.
                                        </li>
                                        <li v-if="role.role_permissions.process.video_instructions.view">
                                            <i class="icofont icofont-stylish-right text-danger"></i>
                                            Can delete Video
                                            Instructions.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <div class="p-b-10">
                            <h4 class="sub-title">Offer Templates</h4>
                            <ul>
                                <li v-if="role.role_permissions.offer_template.create">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can create Offer Templates.
                                </li>
                                <li v-if="role.role_permissions.offer_template.edit">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can edit Offer Templates.
                                </li>
                                <li v-if="role.role_permissions.offer_template.view">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can view Offer Templates.
                                </li>
                            </ul>
                        </div>

                        <div class="p-b-10">
                            <h4 class="sub-title">Scorecard</h4>
                            <ul>
                                <li v-if="role.role_permissions.scorecard.view">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can view Scorecard.
                                </li>
                                <li v-if="role.role_permissions.scorecard.edit">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can edit Scorecard.
                                </li>
                            </ul>
                        </div>

                        <div class="p-b-10">
                            <h4 class="sub-title">Users</h4>
                            <ul>
                                <li v-if="role.role_permissions.users.create">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can create Users.
                                </li>
                                <li v-if="role.role_permissions.users.delete">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can delete Users.
                                </li>
                                <li v-if="role.role_permissions.users.modify">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can modify Users.
                                </li>
                                <li v-if="role.role_permissions.users.change_role">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can change user roles.
                                </li>
                            </ul>
                        </div>

                        <div class="p-b-10">
                            <h4 class="sub-title">Roles</h4>
                            <ul>
                                <li v-if="role.role_permissions.roles.create">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can create Roles.
                                </li>
                                <li v-if="role.role_permissions.roles.delete">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can delete Roles.
                                </li>
                                <li v-if="role.role_permissions.roles.modify">
                                    <i class="icofont icofont-stylish-right text-danger"></i>
                                    Can modify Roles.
                                </li>
                            </ul>
                        </div>


                    </div>
                </div>
            </div>
        </div>
        <div v-if="$checkPerm('roles.create')" v-for="(role, index) in roles" v-bind:id="'editRole' + role.id" class="modal fade"
            role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Modify {{role.role_name}}.</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="editRole(role.id,index)">
                            <div class="form-group">
                                <b>Permissions for {{role.role_name}}:</b>
                                <hr>
                                <div class="row m-t-20">
                                    
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Role
                                                Name:</label>
                                            <input type="text" class="form-control" name="process_name" placeholder="Role Name"
                                                v-model="roles[index].role_name" required="required" />
                                        </div>
                                        <div>
                                            <b class="m-t-10">Opening:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.opening.create"
                                                    name="" />
                                                Create
                                                Opening
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.opening.delete"
                                                    name="" />
                                                Delete
                                                Opening
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.opening.edit"
                                                    name="" />
                                                Edit
                                                Opening
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Archive
                                                Applications:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.archived_applications.view"
                                                    name="" />
                                                View
                                                archived
                                                applications.
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Applications:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.share_to_hiring_manager"
                                                    name="" />
                                                Share
                                                application
                                                to
                                                hiring
                                                manager.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.approve_to_stage_2"
                                                    name="" />
                                                Approve
                                                application
                                                to
                                                "Stage
                                                2".
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.archive"
                                                    name="" />
                                                Archive
                                                application.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.unarchive"
                                                    name="" />
                                                Unarchive
                                                application.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.discontinue"
                                                    name="" />
                                                Discontinue
                                                application.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.approve_for_interview"
                                                    name="" />
                                                Approve
                                                for
                                                interview.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.view_applicant_submissions"
                                                    name="" />
                                                View
                                                applicant
                                                "Stage
                                                2"
                                                submissions.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.create_hiring_note"
                                                    name="" />
                                                Create
                                                hiring
                                                notes.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.view_hiring_note"
                                                    name="" />
                                                View
                                                all
                                                hiring
                                                notes.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.use_scorecard"
                                                    name="" />
                                                Assess
                                                applicant.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.view_all_scorecard_assesments"
                                                    name="" />
                                                View
                                                all
                                                assesment
                                                scorecards.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.use_practical_evaluation"
                                                    name="" />
                                                Do
                                                practical
                                                evaluation.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.send_to_hiring_approver"
                                                    name="" />
                                                Send
                                                application
                                                to
                                                hiring
                                                approver.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.approve_hiring"
                                                    name="" />
                                                Approve
                                                for
                                                hiring.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.forward_offer_to_approver"
                                                    name="" />
                                                Forward
                                                offer
                                                letter
                                                to
                                                approver.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.approve_offer"
                                                    name="" />
                                                Approve
                                                offer
                                                letter.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.forward_offer_to_candidate"
                                                    name="" />
                                                Forward
                                                offer
                                                to
                                                candidate.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.recruit_hr_live"
                                                    name="" />
                                                Recruit
                                                to
                                                HR
                                                Live.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.send_email"
                                                    name="" />
                                                Send
                                                applicant
                                                emails.
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.application.assign_to_evaluator"
                                                    name="" />
                                                Can
                                                assign to
                                                evaluator
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-6">
                                        <div>
                                            <b class="m-t-10">Process:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.process.create"
                                                    name="" />
                                                Create
                                                Process
                                            </div>
                                            <p>CBT:</p>
                                            <div class="m-l-20">
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="roles[index].role_permissions.process.cbt.create"
                                                        name="" />
                                                    Create
                                                    CBT
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="roles[index].role_permissions.process.cbt.view"
                                                        name="" />
                                                    View
                                                    CBT
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="roles[index].role_permissions.process.cbt.assign_to_opening"
                                                        name="" />
                                                    Assign
                                                    CBT
                                                    to
                                                    Opening
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="roles[index].role_permissions.process.cbt.add_questions"
                                                        name="" />
                                                    Add
                                                    questions
                                                    to
                                                    a
                                                    CBT
                                                    test.
                                                </div>
                                            </div>
                                            <p>Video
                                                Instructions:</p>
                                            <div class="m-l-20">
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="roles[index].role_permissions.process.video_instructions.create"
                                                        name="" />
                                                    Create
                                                    new
                                                    Video
                                                    Instructions.
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="roles[index].role_permissions.process.video_instructions.edit"
                                                        name="" />
                                                    Edit
                                                    Video
                                                    Instructions.
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="roles[index].role_permissions.process.video_instructions.delete"
                                                        name="" />
                                                    Delete
                                                    Video
                                                    Instructions.
                                                </div>
                                                <div class="input-group">
                                                    <input type="checkbox" v-model="roles[index].role_permissions.process.video_instructions.delete"
                                                        name="" />
                                                    View
                                                    Video
                                                    Instructions.
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Offer
                                                Templates:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.offer_template.create"
                                                    name="" />
                                                Create
                                                Offer
                                                Templates
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.offer_template.edit"
                                                    name="" />
                                                Edit
                                                Offer
                                                Templates
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.offer_template.view"
                                                    name="" />
                                                View
                                                Offer
                                                Templates
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Scorecard:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.scorecard.edit"
                                                    name="" />
                                                Create
                                                Scorecards
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.scorecard.view"
                                                    name="" />
                                                Edit
                                                Scorecards
                                            </div>
                                        </div>

                                        <div>
                                            <b class="m-t-10">Users:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.users.create"
                                                    name="" />
                                                Create
                                                User
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.users.delete"
                                                    name="" />
                                                Delete
                                                User
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.users.modify"
                                                    name="" />
                                                Edit
                                                User
                                            </div>
                                            <!----<div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.users.change_role"
                                                    name="" />
                                                Edit
                                                Scorecards
                                            </div>-->
                                        </div>

                                        <div>
                                            <b class="m-t-10">Roles:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.roles.create"
                                                    name="" />
                                                Create
                                                Roles
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.roles.delete"
                                                    name="" />
                                                Delete
                                                Roles
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.roles.modify"
                                                    name="" />
                                                Modify
                                                Roles
                                            </div>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="roles[index].role_permissions.roles.modify"
                                                    name="" />
                                                Modify
                                                Roles
                                            </div>
                                        </div>
                                        <div>
                                            <b class="m-t-10">Report:</b>
                                            <hr>
                                            <div class="input-group">
                                                <input type="checkbox" v-model="
                                                    role_permissions.report.view"
                                                    name="" />
                                                View
                                                report
                                            </div>
                                        </div>
                                        <div>
                                            <b class="m-t-10">Social Media :</b>

                                            <div class="input-group">
                                                <input type="checkbox" v-model="role_permissions.socialmedia.create"
                                                    name="" />
                                                Share Social Media Link

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-primary">Edit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-if="$checkPerm('roles.create')" v-for="(role, index) in roles" v-bind:id="'updateRole' + role.id" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Update
                            Role.</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="updateRole(role)">
                            <div class="form-group">
                                <label>Role
                                    Name:</label>
                                <input type="text" class="form-control" name="process_name" placeholder="Role Name"
                                    v-model="role.role_name" required="required" />
                            </div>
                            <div class="form-group text-right">
                                <button class="btn btn-md btn-primary">Edit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<style scoped>
    .pagination {
        display: inline-block;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
        background: #d5d5d5 !important;
    }

    .pagination a.active {
        background: #4CAF50 !important;
        color: white;
    }

    .pagination a:hover:not(.active) {
        background-color: #00ff00;
    }

    ul {
        list-style: none;
    }

    .input-group input {
        margin: 4px !important;
    }
</style>

<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    import Tips from '../components/Tips.vue'

    export default {
        name: 'Stages',
        data() {
            return {
                roles: [],
                new_role: {
                    role_name: "",
                },
                update_role: {
                    role_name: "",
                },
                role_permissions: {
                    "opening": {
                        "create": true,
                        "delete": true,
                        "edit": true,

                    },

                    "archived_applications": {
                        "view": true,
                    },

                    "application": {
                        "share_to_hiring_manager": true,
                        "approve_to_stage_2": true,
                        "assign_to_evaluator": true,
                        "archive": true,
                        "unarchive": true,
                        "discontinue": true,
                        "approve_for_interview": true,
                        "view_applicant_submissions": true,
                        "create_hiring_note": true,
                        "view_hiring_note": true,
                        "use_scorecard": true,
                        "view_all_scorecard_assesments": true,
                        "use_practical_evaluation": true,
                        "send_to_hiring_approver": true,
                        "approve_hiring": true,
                        "forward_offer_to_approver": true,
                        "approve_offer": true,
                        "forward_offer_to_candidate": true,
                        "recruit_hr_live": true,
                        "send_email": true
                    },

                    "process": {
                        "create": true,
                        "cbt": {
                            "create": true,
                            "view": true,
                            "assign_to_opening": true,
                            "add_questions": true,
                        },

                        "video_instructions": {
                            "create": true,
                            "edit": true,
                            "delete": true,
                            "view": true,
                        }
                    },

                    "offer_template": {
                        "create": true,
                        "edit": true,
                        "view": true,
                    },

                    "scorecard": {
                        "edit": true,
                        "view": true
                    },

                    "users": {
                        "create": true,
                        "delete": true,
                        "modify": true,
                        "change_role": true
                    },

                    "roles": {
                        "create": true,
                        "delete": true,
                        "modify": true
                    },
                    "report": {
                        "view": true
                    },
                    "socialmedia": {
                        "create": true
                    }
                }
            }
        },

        components: {
            navbar1,
            navbar2,
            Tips
        },

        mounted() {
            this.init()
        },
        methods: {

            init: function () {
                this.getRoles()
            },

            getRoles: function () {
                var roles = {
                    what: 'GetRoles'
                }
                this.$socket.makeGetRequest(roles)
                    .then((response) => {
                        //this.roles = response.data
                        var data = response.data
                        var d_length = data.length
                        for (var i = 0; i < d_length; i++) {
                            data[i]["role_permissions"] = JSON.parse(data[i]["role_permissions"])

                        }
                        this.roles = data
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            createRole: function () {
                this.new_role.role_permissions = this.role_permissions
                var new_role = {
                    what: 'NewRole',
                    data: this.new_role
                }
                this.$socket.makePostRequest(new_role)
                    .then((response) => {
                        this.$swal.fire('Success', response.data.message, 'success')

                        setTimeout(window.location.reload(), 2000)
                    })
                    .catch((error) => {
                        this.$swal.fire('Error', error.message, 'error')
                    })
            },
            // updateRole: function (role) {
            //     // this.update_role.id = role.id;
            //     var update_role = {
            //         what: 'UpdateRole',
            //         data: role
            //     }
            //     this.$socket.makePostRequest(update_role)
            //         .then((response) => {
            //             this.$swal.fire('Success', response.data.message, 'success')

            //             setTimeout(window.location.reload(), 2000)
            //         })
            //         .catch((error) => {
            //             this.$swal.fire('Error', error.message, 'error')
            //         })
            // },
            editRole: function (id, index) {
                var edit_role = {
                    what: 'EditRole',
                    id: id,
                    data: this.roles[index]
                }
                this.$socket.makeEditRequest(edit_role)
                    .then((response) => {
                        this.$swal.fire('Success', response.message, 'success')
                        setTimeout(window.location.reload(), 2000)
                    })
                    .catch((error) => {
                        this.$swal.fire('Error', error.message, 'error')
                    })
                console.log()
            }
        },
        computed: {

        }
    }
</script>